import React from "react";
import { Routes, Route } from "react-router-dom";
import EnquiresHeader from "../Components/Enquiry/headerEnquires";
import ListProjectsAdmin from "../Components/Enquiry/listProjectsAdmin";
import ListEnquiries from "../Components/Enquiry/listEnquiries";
import UserEnquiries from "../Components/Enquiry/userEnquires";
import ViewEnquiry from "../Components/Enquiry/viewEnquiry";
import ViewUserEnquiry from "../Components/Enquiry/viewUserEnquiry";

const EnquiryRoutes = () => {
  return (
    <Routes>
      <Route
        path="/enquiry"
        element={<EnquiresHeader></EnquiresHeader>}
      ></Route>
      <Route
        path="/project-enquiry"
        element={<ListProjectsAdmin></ListProjectsAdmin>}
      ></Route>
      <Route
        path="/manage_projects/enquiries/:id"
        element={<ListEnquiries></ListEnquiries>}
      ></Route>
      <Route
        path="/enquiry/list"
        element={<ListEnquiries></ListEnquiries>}
      ></Route>
      <Route
        path="/enquiry/user-list"
        element={<UserEnquiries></UserEnquiries>}
      ></Route>
      <Route
        path="/enquiry/view/:id"
        element={<ViewEnquiry></ViewEnquiry>}
      ></Route>
      <Route
        path="/enquiry/user-view/:id"
        element={<ViewUserEnquiry></ViewUserEnquiry>}
      ></Route>
    </Routes>
  );
};

export default EnquiryRoutes;
